import React, { useEffect } from 'react';
import DefaultMsgPage from 'components/DefaultMsgPage';
import { loginDataLayer } from 'utils/dataLayer';

const ResentedEmail: React.FC = () => {
  const handleGoHome = () => {
    window.location.replace(`/home?upd=${new Date().getTime()}`);
  };

  useEffect(() => {
    loginDataLayer.triggerPageViewEvent('atualizar-dados/confirmar-email/link-expirado/novo-email', 3);
  }, []);

  return <DefaultMsgPage traductionKey="resented_email" image="brokenSuitcase" onPrimary={handleGoHome} />;
};

export default ResentedEmail;
